import { GetterTree } from 'vuex'

import { QrCode } from '@/models'

import { orderByLocale } from '@/utils'

import { RootState } from '../state'
import { QrCodesState } from './state'

const getters: GetterTree<QrCodesState, RootState> = {
  /**
   * Returns a QrCode by its id, or null if not found.
   *
   * @param id QrCode id to be found.
   */
  qrCodeById: (state) => (id: number): QrCode | null => {
    return state.elements.find((i) => i.id === id) || null
  },

  /**
   * Returns QrCodes ordered by location name.
   */
  orderedQrCodes (state): QrCode[] {
    return orderByLocale(state.elements, 'location')
  }
}

export default getters
